
class WidgetEvents {
  static init (context) {
    require('../events/forgot-password').call(context)
    require('../events/add-card').call(context)
    require('../events/get-cards').call(context)
    require('../events/guest-mode').call(context)
    require('../events/login').call(context)
    require('../events/logout').call(context)
    require('../events/redeem-code').call(context)
    require('../events/refresh-credits').call(context)
    require('../events/signup').call(context)
    require('../events/submit-rsvp').call(context)
    require('../events/token').call(context)
    require('../events/verify-mobile').call(context)
    require('../events/reservation-details').call(context)
    require('../events/rsvp').call(context)
  }
}

export default WidgetEvents



// WEBPACK FOOTER //
// ./src/modules/events.js